<template>
	<button class="switch" :class="{'switch--checked' : model}" type="button" @click="model = !model">
		<i class="switch__icon"></i>
	</button>
</template>
<script lang="ts" setup>
import "./Switch.scss";

let model = defineModel<boolean>();
</script>